import Head from 'expo-router/head';

import { AuthContainer, ContinueWithEmail } from '@fhs/auth';

export default function ContinueWithEmailPage() {
  return (
    <>
      <Head>
        <title>Sign In - Firehouse Subs</title>
      </Head>
      <AuthContainer>
        <ContinueWithEmail />
      </AuthContainer>
    </>
  );
}
